(function() {
  'use strict';

  var DEBOUNCE_MS = 300;
  var MIN_CHARS = 2;
  var PRODUCT_LIMIT = 8;
  var COLLECTION_LIMIT = 4;
  var DROPDOWN_CLASS = 'nicchia-ps-dropdown';
  var OVERLAY_CLASS = 'nicchia-ps-overlay';

  function debounce(fn, ms) {
    var timer;
    return function() {
      var args = arguments;
      var ctx = this;
      clearTimeout(timer);
      timer = setTimeout(function() { fn.apply(ctx, args); }, ms);
    };
  }

  function formatMoney(price) {
    if (!price && price !== 0) return '';
    var amount = parseInt(price, 10);
    var formatted = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return '$' + formatted;
  }

  function escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function highlightMatch(text, query) {
    if (!query || !text) return escapeHtml(text);
    var escaped = escapeHtml(text);
    var queryEscaped = escapeHtml(query);
    var regex = new RegExp('(' + queryEscaped.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'gi');
    return escaped.replace(regex, '<strong>$1</strong>');
  }

  function getSizedImage(url, size) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    var match = url.match(/\.(jpg|jpeg|png|gif|webp)(\?|$)/i);
    if (match) {
      return url.replace(match[0], '_' + size + '.' + match[1] + (match[2] || ''));
    }
    return url;
  }

  /* --- Dropdown & overlay creation --- */

  function getOrCreateOverlay() {
    var overlay = document.querySelector('.' + OVERLAY_CLASS);
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = OVERLAY_CLASS;
      document.body.appendChild(overlay);
    }
    return overlay;
  }

  var isMouseInDropdown = false;

  function getOrCreateDropdown() {
    var dropdown = document.querySelector('.' + DROPDOWN_CLASS);
    if (!dropdown) {
      dropdown = document.createElement('div');
      dropdown.className = DROPDOWN_CLASS;
      document.body.appendChild(dropdown);

      /* Prevent clicks inside the dropdown from bubbling to body —
         this stops details-modal.js onBodyClick from closing the search modal */
      dropdown.addEventListener('mousedown', function(e) {
        e.stopPropagation();
      });
      dropdown.addEventListener('click', function(e) {
        e.stopPropagation();
      });

      /* Track mouse hover to prevent focusout from closing */
      dropdown.addEventListener('mouseenter', function() {
        isMouseInDropdown = true;
      });
      dropdown.addEventListener('mouseleave', function() {
        isMouseInDropdown = false;
      });
    }
    return dropdown;
  }

  var activeInput = null;

  function positionDropdown(dropdown) {
    var input = activeInput;
    if (!input) return;

    /* Find the closest visible search container or field wrapper */
    var anchor = input.closest('.search-modal__content')
      || input.closest('.search-drawer__inner')
      || input.closest('.search')
      || input.closest('.field')
      || input;

    var rect = anchor.getBoundingClientRect();
    dropdown.style.top = (rect.bottom + window.scrollY) + 'px';

    /* On desktop, center under the search field if it's wide enough */
    var dropW = 780;
    var inputCenter = rect.left + rect.width / 2;
    var left = inputCenter - dropW / 2;

    /* Clamp to viewport */
    if (left < 16) left = 16;
    if (left + dropW > window.innerWidth - 16) left = window.innerWidth - 16 - dropW;

    if (window.innerWidth <= 768) {
      dropdown.style.left = '8px';
      dropdown.style.right = '8px';
      dropdown.style.transform = 'none';
      /* Caret: center of input relative to dropdown */
      var caretMobile = inputCenter - 8;
      dropdown.style.setProperty('--caret-left', Math.max(24, caretMobile) + 'px');
    } else {
      dropdown.style.left = left + 'px';
      dropdown.style.right = 'auto';
      dropdown.style.transform = 'none';
      /* Caret: center of input relative to dropdown left edge */
      var caretLeft = inputCenter - left;
      dropdown.style.setProperty('--caret-left', caretLeft + 'px');
    }
  }

  function showDropdown(dropdown) {
    positionDropdown(dropdown);
    dropdown.classList.add('nicchia-ps-dropdown--open');
    getOrCreateOverlay().classList.add('nicchia-ps-overlay--open');
  }

  function hideDropdown(dropdown) {
    dropdown.classList.remove('nicchia-ps-dropdown--open');
    getOrCreateOverlay().classList.remove('nicchia-ps-overlay--open');
  }

  /* --- Trending tags (empty state) --- */

  var TRENDING_TAGS = ['aromas', 'hombre', 'mujer', 'florales', 'citricos', 'arabes', 'lattafa', 'armaf'];
  var SEARCH_ICON_SVG = '<svg class="nicchia-ps-search-icon" width="12" height="12" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM2 9a7 7 0 1112.45 4.39l3.58 3.58a.75.75 0 11-1.06 1.06l-3.58-3.58A7 7 0 012 9z" fill="currentColor"/></svg>';

  function showTrending(dropdown, input) {
    var html = '<div class="nicchia-ps-trending">';
    html += '<h4 class="nicchia-ps-heading">TENDENCIA AHORA</h4>';
    html += '<div class="nicchia-ps-tags">';
    for (var i = 0; i < TRENDING_TAGS.length; i++) {
      html += '<button type="button" class="nicchia-ps-tag" data-term="' + escapeHtml(TRENDING_TAGS[i]) + '">' +
        SEARCH_ICON_SVG +
        '<span>' + escapeHtml(TRENDING_TAGS[i]) + '</span>' +
      '</button>';
    }
    html += '</div></div>';

    dropdown.innerHTML = html;
    showDropdown(dropdown);

    /* Bind tag clicks — use mousedown so it fires before blur/focusout */
    dropdown.querySelectorAll('.nicchia-ps-tag').forEach(function(tag) {
      tag.addEventListener('mousedown', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var term = this.getAttribute('data-term');
        input.value = term;
        activeInput = input;
        fetchResults(term, dropdown);
        /* Re-focus input after a tick so the modal doesn't close */
        setTimeout(function() { input.focus(); }, 10);
      });
    });
  }

  /* --- Build HTML --- */

  function buildProductsColumn(products, query) {
    if (!products || products.length === 0) {
      return '<div class="nicchia-ps-col nicchia-ps-col--products">' +
        '<h4 class="nicchia-ps-heading">COINCIDENCIAS DE PRODUCTOS</h4>' +
        '<p class="nicchia-ps-no-results">No se encontraron productos.</p>' +
      '</div>';
    }

    var html = '<div class="nicchia-ps-col nicchia-ps-col--products">';
    html += '<h4 class="nicchia-ps-heading">COINCIDENCIAS DE PRODUCTOS</h4>';
    html += '<div class="nicchia-ps-products-grid">';

    for (var i = 0; i < products.length; i++) {
      var p = products[i];
      var img = p.image || (p.featured_image && p.featured_image.url) || '';
      img = getSizedImage(img, '160x160');

      var price = '';
      if (p.price) {
        price = formatMoney(parseInt(p.price, 10));
      } else if (p.price_min) {
        price = formatMoney(parseInt(p.price_min, 10));
      }

      var comparePrice = '';
      var priceNum = parseInt(p.price || p.price_min || 0, 10);
      if (p.compare_at_price && parseInt(p.compare_at_price, 10) > priceNum) {
        comparePrice = formatMoney(parseInt(p.compare_at_price, 10));
      } else if (p.compare_at_price_min && parseInt(p.compare_at_price_min, 10) > priceNum) {
        comparePrice = formatMoney(parseInt(p.compare_at_price_min, 10));
      }

      var vendor = p.vendor || '';

      html += '<a href="' + p.url + '" class="nicchia-ps-product">' +
        '<div class="nicchia-ps-product-img">' +
          (img ? '<img src="' + escapeHtml(img) + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '') +
        '</div>' +
        '<div class="nicchia-ps-product-info">' +
          (vendor ? '<span class="nicchia-ps-product-vendor">' + escapeHtml(vendor) + '</span>' : '') +
          '<span class="nicchia-ps-product-title">' + highlightMatch(p.title, query) + '</span>' +
          '<span class="nicchia-ps-product-price">' +
            (comparePrice ? '<s class="nicchia-ps-product-compare">' + comparePrice + '</s>' : '') +
            (comparePrice ? '<span class="nicchia-ps-product-sale">Desde ' + price + '</span>' : '<span>' + price + '</span>') +
          '</span>' +
        '</div>' +
      '</a>';
    }

    html += '</div></div>';
    return html;
  }

  function buildSidebarColumn(data, query) {
    var queries = (data.resources && data.resources.results && data.resources.results.queries) || [];
    var collections = (data.resources && data.resources.results && data.resources.results.collections) || [];

    var html = '<div class="nicchia-ps-col nicchia-ps-col--sidebar">';

    /* Suggestions */
    if (queries.length > 0) {
      html += '<h4 class="nicchia-ps-heading">SUGERENCIAS</h4>';
      html += '<ul class="nicchia-ps-suggestions">';
      for (var i = 0; i < queries.length; i++) {
        var q = queries[i];
        html += '<li><a href="/search?q=' + encodeURIComponent(q.text) + '&type=product" class="nicchia-ps-suggestion-link">' +
          '<svg class="nicchia-ps-search-icon" width="14" height="14" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM2 9a7 7 0 1112.45 4.39l3.58 3.58a.75.75 0 11-1.06 1.06l-3.58-3.58A7 7 0 012 9z" fill="currentColor"/></svg>' +
          highlightMatch(q.text, query) +
        '</a></li>';
      }
      html += '</ul>';
    }

    /* Collections */
    if (collections.length > 0) {
      html += '<h4 class="nicchia-ps-heading nicchia-ps-heading--collections">COLECCIONES</h4>';
      html += '<ul class="nicchia-ps-collections">';
      for (var j = 0; j < collections.length; j++) {
        var c = collections[j];
        html += '<li><a href="' + c.url + '" class="nicchia-ps-collection-link">' +
          highlightMatch(c.title, query) +
          '<svg class="nicchia-ps-arrow-icon" width="12" height="12" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.5 4.5l5.5 5.5-5.5 5.5" stroke="currentColor" stroke-width="1.5" fill="none"/></svg>' +
        '</a></li>';
      }
      html += '</ul>';
    }

    if (queries.length === 0 && collections.length === 0) {
      html += '<h4 class="nicchia-ps-heading">SUGERENCIAS</h4>';
      html += '<p class="nicchia-ps-no-results">Sin sugerencias.</p>';
    }

    html += '</div>';
    return html;
  }

  function renderResults(dropdown, data, query) {
    var products = (data.resources && data.resources.results && data.resources.results.products) || [];
    var collections = (data.resources && data.resources.results && data.resources.results.collections) || [];
    var queries = (data.resources && data.resources.results && data.resources.results.queries) || [];

    if (products.length === 0 && collections.length === 0 && queries.length === 0) {
      dropdown.innerHTML =
        '<div class="nicchia-ps-empty">' +
          '<svg width="32" height="32" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-bottom:8px;opacity:.3"><path d="M9 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM2 9a7 7 0 1112.45 4.39l3.58 3.58a.75.75 0 11-1.06 1.06l-3.58-3.58A7 7 0 012 9z" fill="currentColor"/></svg>' +
          '<span>No se encontraron resultados para "<strong>' + escapeHtml(query) + '</strong>"</span>' +
        '</div>';
      showDropdown(dropdown);
      return;
    }

    var html = '<div class="nicchia-ps-body">';
    html += buildProductsColumn(products, query);
    html += buildSidebarColumn(data, query);
    html += '</div>';

    html += '<a href="/search?q=' + encodeURIComponent(query) + '&type=product" class="nicchia-ps-view-all">' +
      'Ver todos los resultados para "<strong>' + escapeHtml(query) + '</strong>"' +
      '<svg width="14" height="14" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-left:6px"><path d="M7.5 4.5l5.5 5.5-5.5 5.5" stroke="currentColor" stroke-width="1.5" fill="none"/></svg>' +
    '</a>';

    dropdown.innerHTML = html;
    showDropdown(dropdown);
  }

  /* --- Fetch --- */

  function fetchResults(query, dropdown) {
    var url = '/search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product,query,collection' +
      '&resources[limit]=' + PRODUCT_LIMIT +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,vendor,product_type,variants.title';

    dropdown.innerHTML = '<div class="nicchia-ps-loading"><span class="nicchia-ps-spinner"></span></div>';
    showDropdown(dropdown);

    fetch(url)
      .then(function(res) { return res.json(); })
      .then(function(data) { renderResults(dropdown, data, query); })
      .catch(function() { hideDropdown(dropdown); });
  }

  /* --- Init --- */

  function initInput(input) {
    if (input.dataset.nicchiaPsInit) return;
    input.dataset.nicchiaPsInit = 'true';

    var dropdown = getOrCreateDropdown();
    var overlay = getOrCreateOverlay();

    var onInput = debounce(function() {
      var q = input.value.trim();
      if (q.length < MIN_CHARS) {
        hideDropdown(dropdown);
        return;
      }
      fetchResults(q, dropdown);
    }, DEBOUNCE_MS);

    input.addEventListener('input', function() {
      activeInput = input;
      if (input.value.trim().length === 0) {
        showTrending(dropdown, input);
        return;
      }
      onInput();
    });

    input.addEventListener('focus', function() {
      activeInput = input;
      if (input.value.trim().length === 0) {
        showTrending(dropdown, input);
      } else if (input.value.trim().length >= MIN_CHARS && dropdown.innerHTML) {
        showDropdown(dropdown);
      }
    });

    /* Intercept focusout — if mouse is over our dropdown, prevent the theme's
       predictive-search.js onFocusOut from closing/clearing things */
    var psElement = input.closest('predictive-search');
    if (psElement) {
      psElement.addEventListener('focusout', function(e) {
        if (isMouseInDropdown) {
          e.stopImmediatePropagation();
        }
      }, true);
    }

    /* Use mousedown on overlay so it fires before blur */
    overlay.addEventListener('mousedown', function(e) {
      e.preventDefault();
      hideDropdown(dropdown);
    });

    /* Close on outside click — but NOT if mouse is in dropdown */
    document.addEventListener('mousedown', function(e) {
      if (isMouseInDropdown) return;
      if (dropdown.contains(e.target)) return;
      if (e.target === input || input.contains(e.target)) return;
      /* Don't close if clicking the overlay (handled above) */
      if (e.target === overlay) return;
      hideDropdown(dropdown);
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        hideDropdown(dropdown);
        input.blur();
      }
    });
  }

  function findAndInit() {
    var inputs = document.querySelectorAll('input[type="search"].search__input, input[name="q"][type="search"]');
    for (var i = 0; i < inputs.length; i++) {
      initInput(inputs[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', findAndInit);
  } else {
    findAndInit();
  }

  var observer = new MutationObserver(debounce(findAndInit, 100));
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'style', 'class'] });
})();
